import { Injectable } from "@angular/core";

@Injectable({
    providedIn: "root"
})
export class CalendarService {
    /**
     * dateRange returns an array of year-month dates between the supplied start and end dates
     * @param startDate Date or natively parseable string (e.g. 2024-04-01)
     * @param endDate Date or natively parseable string (e.g. 2024-04-01)
     * @returns string[] of ISO 8601 strings for each month between start and end
     */
    getMonthsBetweenDates(startDate: string, endDate: string): Date[] {
        const start = new Date(startDate);
        const end = new Date(endDate);
        const dates: Date[] = [];
        
        // Always work with the first day of the month to avoid day-of-month comparison issues
        let currentMonth = new Date(start.getFullYear(), start.getMonth(), 1);
        const endMonth = new Date(end.getFullYear(), end.getMonth(), 1);
        
        while (currentMonth.getTime() <= endMonth.getTime()) {
            // Add the first day of the current month
            dates.push(new Date(currentMonth));
            
            // Move to the first day of the next month
            currentMonth.setMonth(currentMonth.getMonth() + 1);
        }

        return dates;
    }


    getLastDayOfMonth(date: Date) {
        return new Date(date.getFullYear(), date.getMonth() + 1, 0);
    }

    convertToStringDateWithTimezone(date: Date): string {
        const options: Intl.DateTimeFormatOptions = {
            timeZone: 'Europe/Stockholm',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        };

        // Make the date into the format "YYYY-MM-DD"
        return new Intl.DateTimeFormat('sv-SE', options).format(date);
    }

}